import React from 'react'
import { CSSTransitionGroup } from 'react-transition-group'

import './css/Invite.css'
import InviteForm from './InviteForm'
import InviteText from './text/invite-text'

export default class Invite extends React.Component {
  state = { in: true }

  renderInviteContainer = () => (
    <div className="invite-body">
      <div className="invite-line small-text">{InviteText[1]}</div>
      <div className="invite-line small-text">{InviteText[2]}</div>
      <div className="invite-line small-text">{InviteText[3]}</div>
      <div className="invite-form">
        <InviteForm isInvitePage={true} />
      </div>
    </div>
  )

  render() {
    return (
      <div>
        <div className="bar-blue invite-blue" />
        <CSSTransitionGroup
          transitionName="slide"
          transitionAppear={true}
          transitionAppearTimeout={500}
          transitionLeaveTimeout={500}
          transitionEnter={false}
          transitionLeave={true}>
          <div className="invite-container">
            <div className="header">{InviteText[0]}</div>
            {this.renderInviteContainer()}
          </div>  
        </CSSTransitionGroup>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/Invite.js